import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/Footer.jsx";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';
import './style.css';
import { useTranslation } from 'react-i18next';
import { FaTrash } from "react-icons/fa";
import { FaUserEdit } from "react-icons/fa";
// 1. Import xlsx
import * as XLSX from 'xlsx';

const ClientUsers = () => {
    const { t } = useTranslation();
    const [suppliers, setSuppliers] = useState([]);
const [isAdmin, setIsAdmin] = useState(
    localStorage.getItem("isAdmin") === "1"
);
    const [showModal, setShowModal] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [deviationBonus, setDeviationBonus] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [deletedSuppliers, setDeletedSuppliers] = useState(new Set()); 
    const [searchTerm, setSearchTerm] = useState("");
    const role = localStorage.getItem("role");
    const admin_type = localStorage.getItem("admin_type");

   useEffect(() => {
    if (isAdmin) {
        fetchAllSuppliers();
    }
}, [isAdmin, currentPage]);
    const fetchAllSuppliers = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) return;
            
            let url = `https://rehabwmg.online/api/admin/users?page=${currentPage}`;
            if (admin_type === 'influenceur') {
                url = `https://rehabwmg.online/api/admin/InfluenceurClientFusers?page=${currentPage}`;
            } else if (admin_type === 'supplier') {
                url = `https://rehabwmg.online/api/admin/AdminDistrubuteurUsers?page=${currentPage}`;
            }

            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                setSuppliers(response.data.data || []);
                setTotalPages(response.data.last_page || 1);
            }
        } catch (error) {
            return;
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // 2. Excel Export Function
const exportToExcel = async () => {
    try {
        const token = localStorage.getItem('authToken');
        if (!token) return;

        // 1. Show a loading alert so the admin knows it's fetching multiple pages
        Swal.fire({
            title: t('Préparation de l\'export...'),
            text: t('Récupération de toutes les données en cours, veuillez patienter...'),
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        let allUsers = [];
        let page = 1;
        let hasMorePages = true;

        // 2. Loop through all pages in the background
        while (hasMorePages) {
            let url = `https://rehabwmg.online/api/admin/users?page=${page}`;
            if (admin_type === 'influenceur') {
                url = `https://rehabwmg.online/api/admin/ClientFideleusers?page=${page}`;
            } else if (admin_type === 'supplier') {
                url = `https://rehabwmg.online/api/admin/AdminInfluenceurUsers?page=${page}`;
            }

            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200 && response.data) {
                const pageData = response.data.data || [];
                
                if (pageData.length === 0) {
                    hasMorePages = false;
                } else {
                    allUsers = [...allUsers, ...pageData];
                    
                    // Check if we've reached the last page using Laravel's meta counters
                    if (page >= (response.data.last_page || 1)) {
                        hasMorePages = false;
                    } else {
                        page++; // Move to next page for next iteration
                    }
                }
            } else {
                hasMorePages = false;
            }
        }

        // 3. Close loading alert
        Swal.close();

        if (allUsers.length === 0) {
            Swal.fire("Info", "Aucune donnée à exporter", "info");
            return;
        }

        // 4. Apply search filters to the full dataset if a search term exists
  
const totalFiltered = allUsers.filter((supplier) => {
    const hasAllowedRole =
        supplier.role?.toLowerCase() === "client_fidele";

    const matchesSearch =
        supplier.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        supplier.custom_id?.toLowerCase().includes(searchTerm.toLowerCase());

    return hasAllowedRole && matchesSearch;
});
        // 5. Map fields to clean French column headers matching image_c0dc1f.jpg layout
        const excelData = totalFiltered.map(supplier => ({
            "Identifiant": supplier.custom_id || '',
            "Nom": supplier.name || '',
            "Email": supplier.email || '',
            "Numéro de Téléphone": supplier.phone || '',
            "Adresse": supplier.address || '',
            "Rôle": supplier.role === 'supplier' ? 'Distributeur' : (supplier.role || 'Aucun rôle'),
            "Date de création": supplier.created_at ? new Date(supplier.created_at).toLocaleString() : ''
        }));

        // 6. Build and Download Excel Sheet
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Tous les Utilisateurs");

        XLSX.writeFile(workbook, `Utilisateurs_Complet_RehabBio_${new Date().toISOString().slice(0,10)}.xlsx`);

    } catch (error) {
        Swal.close();
        Swal.fire("Erreur", "Impossible de récupérer toutes les pages de données.", "error");
        console.error("Excel Export Error: ", error);
    }
};
    if (!isAdmin) {
        return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
    }


const filteredSuppliers = (suppliers || []).filter((supplier) => {
    const hasAllowedRole =
        supplier.role?.toLowerCase() === "client_fidele";

    const matchesSearch =
        supplier.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        supplier.custom_id?.toLowerCase().includes(searchTerm.toLowerCase());

    return hasAllowedRole && matchesSearch;
});

    const banUser = async (supplierId) => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await axios.delete(`https://rehabwmg.online/api/admin/user/${supplierId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                setDeletedSuppliers((prev) => new Set(prev.add(supplierId)));
                Swal.fire("Success", "Utilisateur supprimé avec succès!", "success");
                fetchAllSuppliers();
            }
        } catch (error) {
            Swal.fire("Error", error.response?.data || "Something went wrong", "error");
        }
    };

    const ActiverUserAccount = async (supplierId) => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await axios.put(`https://rehabwmg.online/api/admin/activerUser/${supplierId}`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                Swal.fire("Success", "Utilisateur activé avec succès!", "success");
                fetchAllSuppliers();
            }
        } catch (error) {
            Swal.fire("Error", error.response?.data || "Something went wrong", "error");
        }
    };

    const deleteUser = async (userId) => {
        const confirm = await Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer",
            cancelButtonText: "Annuler",
        });
        if (!confirm.isConfirmed) return;

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.delete(`https://rehabwmg.online/api/admin/delete/${userId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.status === 200) {
                Swal.fire("Supprimé !", "Utilisateur supprimé avec succès.", "success");
                fetchAllSuppliers();
            }
        } catch (error) {
            Swal.fire("Erreur", error.response?.data?.message || "Échec de la suppression", "error");
        }
    };

    const changeUserRole = async (userId, currentRole) => {
        const { value: role } = await Swal.fire({
            title: "Changer le rôle",
            input: "select",
            inputOptions: {
                supplier: "Distributeur",
                influenceur: "Influenceur",
                client_fidele: "client_fidele",
            },
            inputValue: currentRole,
            showCancelButton: true,
            confirmButtonText: "Changer",
            cancelButtonText: "Annuler",
        });
        if (!role) return;

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.put(`https://rehabwmg.online/api/admin/user/${userId}/role`, { role }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.status === 200) {
                Swal.fire("Succès", "Rôle modifié avec succès", "success");
                fetchAllSuppliers();
            }
        } catch (error) {
            Swal.fire("Erreur", error.response?.data?.message || "Échec de la modification", "error");
        }
    };

    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex flex-column flex-md-row">
                <section className="w-100 p-3">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                        <h1 className="text-dark display-4 m-0">{t('Tableau_de_bord_Utilisateurs')}</h1>
                        
                        {/* 3. Action Containers Grouped Side-by-Side */}
                  {/* 3. Action Containers Grouped Side-by-Side */}
<div className="d-flex gap-2 align-items-center">
    <button 
        className="btn btn-success" 
        onClick={exportToExcel}
        style={{ fontWeight: '500', whiteSpace: 'nowrap' }} // Added whiteSpace: 'nowrap' to prevent text wrapping
    >
        📊 {t('Exporter en Excel')}
    </button>
    <input
        type="text"
        className="form-control"
        placeholder={t('Rechercher_par_nom_id')}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ maxWidth: '300px', height: '100%' }} // height matches the button execution flow
    />
</div>                    </div>
                    <hr className="my-4" />

                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th>{t('Identifiant')}</th>
                                    <th>{t('Nom')}</th>
                                    <th>{t('Email')}</th>
                                    <th>{t('Numéro_de_Téléphone')}</th>
                                    <th>{t('Adresse')}</th>
                                    <th>{t('Role')}</th>
                                    <th>{t('created_at')}</th>
                                    <th>{t('Actions')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredSuppliers && filteredSuppliers.length > 0 ? (
                                    filteredSuppliers.map((supplier) => (
                                        <tr key={supplier.id}>
                                            <td>{supplier.custom_id}</td>
                                            <td>{supplier.name}</td>
                                            <td>{supplier.email}</td>
                                            <td>{supplier.phone}</td>
                                            <td>{supplier.address}</td>
                                            <td>
                                                {supplier.role === 'supplier' ? 'Distributeur' : supplier.role ?? 'Aucun rôle'}
                                            </td>  
                                            <td>{new Date(supplier.created_at).toLocaleString()}</td>
                                            <td className="d-flex gap-2">
                                                <button className="btn btn-danger btn-sm" onClick={() => banUser(supplier.id)} disabled={supplier.is_deleted}>
                                                    {t("BAN")}
                                                </button>
                                                <button className="btn btn-success btn-sm" onClick={() => ActiverUserAccount(supplier.id)} disabled={supplier.compteVerified}>
                                                    {t("Activer")}
                                                </button>
                                                <button className="btn btn-outline-danger btn-sm" onClick={() => deleteUser(supplier.id)} title="Supprimer l'utilisateur">
                                                    <FaTrash />
                                                </button>
                                                <button className="btn btn-outline-primary btn-sm" title="Changer le rôle" onClick={() => changeUserRole(supplier.id, supplier.role)}>
                                                    <FaUserEdit />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center">Aucun utilisateur trouvé.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>


<div className="d-flex justify-content-center">
    <nav>
        <ul className="pagination">

            {/* Previous */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button
                    className="page-link"
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                >
                    Précédente
                </button>
            </li>

            {/* Show up to 10 page numbers */}
            {Array.from(
                { length: Math.min(10, totalPages) },
                (_, index) => {
                    let page;

                    if (totalPages <= 10 || currentPage <= 5) {
                        page = index + 1;
                    } else if (currentPage > totalPages - 5) {
                        page = totalPages - 9 + index;
                    } else {
                        page = currentPage - 4 + index;
                    }

                    return (
                        <li
                            key={page}
                            className={`page-item ${
                                currentPage === page ? "active" : ""
                            }`}
                        >
                            <button
                                className="page-link"
                                onClick={() => handlePageChange(page)}
                            >
                                {page}
                            </button>
                        </li>
                    );
                }
            )}

            {/* Next */}
            <li
                className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                }`}
            >
                <button
                    className="page-link"
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(currentPage + 1)}
                >
                    Suivante
                </button>
            </li>

        </ul>
    </nav>
</div>

</section>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default ClientUsers;